<div class="container-xxl">
    <nav class="navbar fixed-top navbar-expand-lg navbar-dark themeBg p-0">
        <div class="container-fluid">
            <a class="navbar-brand p-0" href="javascript:void(0)">
                <div class="logo-wrapper ps-0" (click)="goToHome()">
                    <a href="javascript:void(0)">
                        <img src="assets/img/logo.png" alt="Crexendo Logo Powered By NetSapiens">
                    </a>
                    <span *ngIf="environment.envIndicator" class="badge bg-light text-dark env-indicator">Dev</span>
                    <span *ngIf="environment.staging" class="badge bg-light text-dark env-indicator">Staging</span>
                </div>
            </a>
            <!-- <div class="justify-content-end float-end" *ngIf="isMngLoggedIn">
                <form class="form-inline nav-search">
                    <input class="form-control form-control-sm" type="search" placeholder="Search" aria-label="Search">
                    <button class="btn btn-light btn-sm nav-search-btn" type="submit">Go</button>
                </form>
            </div> -->
            <div *ngIf="isMngLoggedIn" class="mng-user-profile-wrapper">
                <div class="collapse navbar-collapse justify-content-end navbar-collapse-bs-org" id="navbarNavDropdown">
                    <ul class="navbar-nav pe-0">

                        <li class="nav-item dropdown user-profile mng-user-profile">
                            <a class="nav-link dropdown-toggle pe-0" href="javascript:void(0)"
                                id="navbarDropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <!-- <i class="fa-solid fa-gear fa-fw" style="color: #fff;
                                font-size: 20px;
                                padding-top: 14px;
                                float: right;"></i> -->
                                <div *ngIf="mngUser" class="detail-info ">
                                    <span>{{mngUser.name}} </span>
                                    <span class="">
                                        {{mngUser.email}}
                                    </span>
                                    <span class="d-none d-lg-inline-block" *ngIf="lastLoginDate">
                                        Last Login:&nbsp;{{lastLoginDate}}
                                    </span>
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-end dropdown-menu-lg-left-end pullDown "
                                aria-labelledby="navbarDropdownMenuLink">
                                <!--  <a class="dropdown-item" href="javascript:void(0)">Settings</a> -->
                                <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">Logout</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hamburger-icon" id="mobileMenuMng" (click)="toggleMenu()">&#9776;</div>
            <div class="mobile-menu-container-mng" id="mobileMenuListMng" [ngClass]="{'open' : isMenuOpen}">
                <app-mng-menu-list [mngUser]="mngUser" [userLastLoginDate]="lastLoginDate"></app-mng-menu-list>
            </div>
        </div>
    </nav>
</div>